export default __webpack_public_path__ + "static/media/agrosemesumo.cc7ac3c4.jpg";